import styled from 'styled-components'
import BeforeAfter from '../../Create/components/HomeTitle/BeforeAfter'
import compareBefore from '../../../assets/ai-studio-landing/compare_dm/before.png'
import compareAfter from '../../../assets/ai-studio-landing/compare_dm/after.png'

const SectionWrapper = styled.section`
  width: 100%;
  padding: 80px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 26px;
  background: white;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 60px 20px;
  }
`

const SectionTitle = styled.h2`
  color: black;
  font-size: 48px;
  font-weight: 500;
  text-align: center;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 32px;
  }
`

const SectionSubtitle = styled.p`
  color: #3F3F3F;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  margin: 0;
  max-width: 842px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`

const ComparisonWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  justify-content: center;
`

const ActionButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 322px;
  height: 50px;
  background: linear-gradient(270deg, #FF996E 0%, #FF5565 37%, #FF4576 75%, #FF5E84 100%);
  border-radius: 100px;
  color: white;
  font-size: 18px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 300px;
  }
`

const AIBeforeAfterSection = ({ onActionClick }) => {
  return (
    <SectionWrapper>
      <SectionTitle>See the Power of AI Interior Design.</SectionTitle>
      <SectionSubtitle>
        Upload a real room or start from scratch. AI instantly transforms rooms into realistic, magazine-ready designs — guided by your style, colors, and materials.
      </SectionSubtitle>

      <ComparisonWrapper>
        <BeforeAfter
          maxWidth="1022px"
          aspectRatio="1022 / 655"
          sliderLineWidth={9}
          beforeSrc={compareBefore}
          afterSrc={compareAfter}
        />
      </ComparisonWrapper>

      <ActionButton onClick={onActionClick}>Design With AI</ActionButton>
    </SectionWrapper>
  )
}

export default AIBeforeAfterSection
